import request from '@/utils/request'

const contractApi = {
  trade_contract_list: '/trade/contract/',
  trade_contract_create: '/trade/contract/',
  trade_contract_update: '/trade/contract/',
  trade_contract_delete: '/trade/contract/',
  trade_contract_archived: '/trade/contract_archived/',
  trade_storage_contract: '/trade/storage_contract/',
  trade_storage_contract_archived: '/trade/storage_contract_archived/',
  trade_insurance_contract: '/trade/insurance_contract/',
  trade_insurance_contract_archived: '/trade/insurance_contract_archived/',
  trade_insurance_contract_attachment: '/trade/insurance_contract_attachment/',
  trade_charter_party_contract: '/trade/charter_party_contract/',
  trade_charter_party_contract_archived: '/trade/charter_party_contract_archived/',
  trade_booking_contract: '/trade/booking_contract/',
  trade_booking_contract_archived: '/trade/booking_contract_archived/',
  trade_inspection_contract: '/trade/inspection_contract/',
  trade_inspection_contract_archived: '/trade/inspection_contract_archived/',
  trade_freight_forwarding_contract: '/trade/freight_forwarding_contract/',
  trade_freight_forwarding_contract_archived: '/trade/freight_forwarding_contract_archived/',
  trade_loading_supervision_contract: '/trade/loading_supervision_contract/',
  trade_loading_supervision_contract_archived: '/trade/loading_supervision_contract_archived/',
  trade_supervision_contract: '/trade/supervision_contract/',
  trade_supervision_contract_archived: '/trade/supervision_contract_archived/',
  trade_common_contract_record: '/trade/common_contract_record/',
  trade_guarantee_contract_record: '/trade/guarantee_contract_record/',
  trade_generate_contract_number: '/trade/generate_contract_number/'
}

/**
 * 列表
 */
export function contract_list (parameter) {
  return request({
    url: contractApi.trade_contract_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function contract_create (parameter) {
  return request({
    url: contractApi.trade_contract_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 添加
 */
export function storage_contract_create (parameter) {
  return request({
    url: contractApi.trade_storage_contract,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function storage_contract_archived (parameter) {
  return request({
    url: contractApi.trade_storage_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 列表
 */
export function storage_contract_list (parameter) {
  return request({
    url: contractApi.trade_storage_contract,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 修改
 */
export function storage_contract_update (parameter, contract_id) {
  return request({
    url: contractApi.trade_storage_contract + contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 删除
 */
export function storage_contract_delete (contract_id) {
  return request({
    url: contractApi.trade_storage_contract + contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 修改
 */
export function contract_update (parameter, contract_id) {
  return request({
    url: contractApi.trade_contract_update + contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function contract_delete (contract_id) {
  return request({
    url: contractApi.trade_contract_delete + contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function contract_archived (parameter) {
  return request({
    url: contractApi.trade_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 保险合同创建
 */
export function insurance_contract_create (parameter) {
  return request({
    url: contractApi.trade_insurance_contract,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 保险合同存档
 * @param parameter
 * @returns {AxiosPromise}
 */
export function insurance_contract_archived (parameter) {
  return request({
    url: contractApi.trade_insurance_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 保险合同
 * 删除附件
 * @param parameter
 * @returns {AxiosPromise}
 */
export function insurance_contract_attachment_delete (attachment_id) {
  return request({
    url: contractApi.trade_insurance_contract_attachment + attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 保险合同列表
 */
export function insurance_contract_list (parameter) {
  return request({
    url: contractApi.trade_insurance_contract,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 保险合同修改
 */
export function insurance_contract_update (parameter, contract_id) {
  return request({
    url: contractApi.trade_insurance_contract + contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 保险合同删除
 * @param contract_id
 * @returns {AxiosPromise}
 */
export function insurance_contract_delete (contract_id) {
  return request({
    url: contractApi.trade_insurance_contract + contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 租船合同创建
 */
export function charter_party_contract_create (parameter) {
  return request({
    url: contractApi.trade_charter_party_contract,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 租船合同存档
 * @param parameter
 * @returns {AxiosPromise}
 */
export function charter_party_contract_archived (parameter) {
  return request({
    url: contractApi.trade_charter_party_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 租船合同列表
 */
export function charter_party_contract_list (parameter) {
  return request({
    url: contractApi.trade_charter_party_contract,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 租船合同修改
 */
export function charter_party_contract_update (parameter, contract_id) {
  return request({
    url: contractApi.trade_charter_party_contract + contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 租船合同删除
 * @param contract_id
 * @returns {AxiosPromise}
 */
export function charter_party_contract_delete (contract_id) {
  return request({
    url: contractApi.trade_charter_party_contract + contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 订舱合同创建
 */
export function booking_contract_create (parameter) {
  return request({
    url: contractApi.trade_booking_contract,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 订舱合同存档
 * @param parameter
 * @returns {AxiosPromise}
 */
export function booking_contract_archived (parameter) {
  return request({
    url: contractApi.trade_booking_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 订舱合同列表
 */
export function booking_contract_list (parameter) {
  return request({
    url: contractApi.trade_booking_contract,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 订舱合同修改
 */
export function booking_contract_update (parameter, contract_id) {
  return request({
    url: contractApi.trade_booking_contract + contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 订舱合同删除
 * @param contract_id
 * @returns {AxiosPromise}
 */
export function booking_contract_delete (contract_id) {
  return request({
    url: contractApi.trade_booking_contract + contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 商检合同创建
 */
export function inspection_contract_create (parameter) {
  return request({
    url: contractApi.trade_inspection_contract,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 商检合同存档
 * @param parameter
 * @returns {AxiosPromise}
 */
export function inspection_contract_archived (parameter) {
  return request({
    url: contractApi.trade_inspection_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 商检合同列表
 */
export function inspection_contract_list (parameter) {
  return request({
    url: contractApi.trade_inspection_contract,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 商检合同修改
 */
export function inspection_contract_update (parameter, contract_id) {
  return request({
    url: contractApi.trade_inspection_contract + contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 商检合同删除
 * @param contract_id
 * @returns {AxiosPromise}
 */
export function inspection_contract_delete (contract_id) {
  return request({
    url: contractApi.trade_inspection_contract + contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 货代合同创建
 */
export function freight_forwarding_contract_create (parameter) {
  return request({
    url: contractApi.trade_freight_forwarding_contract,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 货代合同存档
 * @param parameter
 * @returns {AxiosPromise}
 */
export function freight_forwarding_contract_archived (parameter) {
  return request({
    url: contractApi.trade_freight_forwarding_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 货代合同列表
 */
export function freight_forwarding_contract_list (parameter) {
  return request({
    url: contractApi.trade_freight_forwarding_contract,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 货代合同修改
 */
export function freight_forwarding_contract_update (parameter, contract_id) {
  return request({
    url: contractApi.trade_freight_forwarding_contract + contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 货代合同删除
 * @param contract_id
 * @returns {AxiosPromise}
 */
export function freight_forwarding_contract_delete (contract_id) {
  return request({
    url: contractApi.trade_freight_forwarding_contract + contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 监装合同创建
 */
export function loading_supervision_contract_create (parameter) {
  return request({
    url: contractApi.trade_loading_supervision_contract,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 监装合同存档
 * @param parameter
 * @returns {AxiosPromise}
 */
export function loading_supervision_contract_archived (parameter) {
  return request({
    url: contractApi.trade_loading_supervision_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 监装合同列表
 */
export function loading_supervision_contract_list (parameter) {
  return request({
    url: contractApi.trade_loading_supervision_contract,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 监装合同修改
 */
export function loading_supervision_contract_update (parameter, contract_id) {
  return request({
    url: contractApi.trade_loading_supervision_contract + contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 监装合同删除
 * @param contract_id
 * @returns {AxiosPromise}
 */
export function loading_supervision_contract_delete (contract_id) {
  return request({
    url: contractApi.trade_loading_supervision_contract + contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 监管合同创建
 */
export function supervision_contract_create (parameter) {
  return request({
    url: contractApi.trade_supervision_contract,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 监管合同存档
 * @param parameter
 * @returns {AxiosPromise}
 */
export function supervision_contract_archived (parameter) {
  return request({
    url: contractApi.trade_supervision_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 监管合同列表
 */
export function supervision_contract_list (parameter) {
  return request({
    url: contractApi.trade_supervision_contract,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 监管合同修改
 */
export function supervision_contract_update (parameter, contract_id) {
  return request({
    url: contractApi.trade_supervision_contract + contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 监管合同删除
 * @param contract_id
 * @returns {AxiosPromise}
 */
export function supervision_contract_delete (contract_id) {
  return request({
    url: contractApi.trade_supervision_contract + contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 合同修改记录
 */
export function common_contract_record_list (parameter) {
  return request({
    url: contractApi.trade_common_contract_record,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 合同修改记录
 */
export function guarantee_contract_record_list (parameter) {
  return request({
    url: contractApi.trade_guarantee_contract_record,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

export function generate_contract_number (parameter) {
  return request({
    url: contractApi.trade_generate_contract_number,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
